import React, {useContext} from "react";
import PropTypes from "prop-types";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import UserContext from "../../UserContext";

const styles = {
    sortIcon: {
        width: 18,
        height: 18,
        marginLeft: 0,
    },
    sortable: {
        cursor: 'pointer',
        float: "left",
        minWidth: "15px",
        fontSize: 'small',
        paddingLeft: '0px',
        paddingRight: '0px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'inline-block'
    },
    unsortable: {
        cursor: 'pointer',
        float: "left",
        fontSize: 'small',
        paddingRight: '0px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'inline-block',
        marginRight: '-10px'
    }
};


function ArgoListSortColumn(props) {

    const {
        title = "Name",
        sortable = true,
        gridState = {},
        onSortChange = function () {},
        align = "left",
        width = "100%",
        height = "40px",
        icon: iconProp,
        padding,
        id
    } = props;

    const theme = useContext(UserContext); // From blueTheme.js

    const titleClickHandler = () => {
        let direction = gridState.direction === "asc" ? "desc" : "asc";
        if (title !== gridState.name) {
            direction = "asc";
        }
        onSortChange(title, direction);
    };

    let vLabelColor = sortable ? "#01579B" : "gray";
    let html;
    let sortIcon;

    if (title === gridState.name)
        switch (gridState.direction) {
            case 'desc':
                sortIcon = <ArrowDownwardIcon style={{...styles.sortIcon, color: "rgba(0, 0, 0, 0.54 )"}}/>;
                break;
            case 'asc':
                sortIcon = <ArrowUpwardIcon style={{...styles.sortIcon, color: "rgba(0, 0, 0, 0.54 )"}}/>;
                break;
            default:
                sortIcon = '';
                break;
        }

    if (sortable) {
        html = (
            <div tabIndex={0}
                 role="button"
                 style={{
                ...styles.sortable,
                color: vLabelColor,
                textAlign: align,
                width: width,
                padding: padding}}
                onClick={titleClickHandler}
                onKeyDown={(e) => {
                   if (e.key === "Enter" || e.key === " ") {
                       e.preventDefault()
                       titleClickHandler()
                   }
                }}
                >
                <table>
                    <tbody>
                    {iconProp === undefined && sortIcon === undefined ?
                        <tr style={{ height: height }}>
                            <td id={id} style={{color: theme.palette.listSortColumnTextColor, textAlign: align}}>
                                {title}
                            </td>
                        </tr>
                        :
                        <tr style={{ height: height }}>
                            <td id="SortIcon" style={{...styles.sortIcon}}>
                                {sortIcon}
                            </td>
                            <td id={id} style={{textAlign: "left"}}>
                                {iconProp ? iconProp : title}
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        );
    }
    else // NOT Sortable
    {
        html = (
            <div id={id} style={{
                ...styles.unsortable,
                color: vLabelColor,
                textAlign: align,
                width: width,
                minWidth: (title === "Pin") ? "15px" : "0px",
                paddingLeft: (title === "Pin") ? "15px" : "0px",}}>
                {title}
            </div>);
    }
    return (html);
}

ArgoListSortColumn.propTypes = {
    title: PropTypes.string,
    sortable: PropTypes.bool,
    gridState: PropTypes.object,
    onSortChange: PropTypes.func,
    listIdentifier: PropTypes.string,
    align: PropTypes.oneOf(["left", "right", "center"]),
    width: PropTypes.string,
    height: PropTypes.string,
    icon: PropTypes.object,
    padding: PropTypes.string
};

export default ArgoListSortColumn;
